import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { injectIntl } from 'react-intl';
// helper
import messages from '../../../locale/messages';
// components
import AdminDashboardUserCard from './AdminDashboardUserCard';

// style
import s from './AdminDashboard.css';

export class AdminDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            socketResEaters: null,
            socketResShops: null,
            socketResDrivers: null,
            socketResBooking: null,
            socketResEarnings: null
        }
    }

    componentDidMount() {
        const { socket } = this.props;

        if (socket) {
            socket.on(`eatersCount`, (data) => {
                this.setState({ socketResEaters: JSON.parse(data) })
            });
            socket.on(`driversCount`, (data) => {
                this.setState({ socketResDrivers: JSON.parse(data) })
            });
            socket.on(`shopsCount`, (data) => {
                this.setState({ socketResShops: JSON.parse(data) })
            });
            socket.on(`bookingsCount`, (data) => {
                this.setState({ socketResBooking: JSON.parse(data) })
            });
            socket.on(`bookingEarnings`, (data) => {
                this.setState({ socketResEarnings: JSON.parse(data) })
            });
        }
    }

    componentWillUnmount() {
        const { socket } = this.props;
        if (socket) {
            socket.removeListener(`eatersCount`);
            socket.removeListener(`driversCount`);
            socket.removeListener(`shopsCount`);
            socket.removeListener(`bookingsCount`);
            socket.removeListener(`bookingEarnings`);
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { orders, earnings, users, drivers, shops, toCurrency, socket, isSuperAdmin, privilegesIds } = this.props;
        const { socketResEaters, socketResShops, socketResDrivers, socketResBooking, socketResEarnings } = this.state;
        const isEarningsEnable = isSuperAdmin || privilegesIds && privilegesIds.length > 0 && privilegesIds.includes(12);

        return (
            <div>
                <Container fluid>
                    <Row>
                        <AdminDashboardUserCard
                            data={socketResEaters || users}
                            heading={formatMessage(messages.eaters)}
                            link={'/siteadmin/users'}
                        />
                        <AdminDashboardUserCard
                            data={socketResShops || shops}
                            heading={formatMessage(messages.restaurants)}
                            link={'/siteadmin/restaurant/list'}
                        />
                        <AdminDashboardUserCard
                            data={socketResDrivers || drivers}
                            heading={formatMessage(messages.drivers)}
                            link={'/siteadmin/drivers'}
                        />
                        <AdminDashboardUserCard
                            data={socketResBooking || orders}
                            heading={formatMessage(messages.bookings)}
                            link={'/siteadmin/bookings'}
                        />
                        {
                            isEarningsEnable &&
                            <AdminDashboardUserCard
                                data={socketResEarnings || earnings}
                                heading={formatMessage(messages.earnings)}
                                link={'/siteadmin/admin-earnings'}
                                displayAmount={true}
                                toCurrency={toCurrency}
                            />
                        }
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    toCurrency: state.siteSettings && state.siteSettings.data && state.siteSettings.data.currency,
    isSuperAdmin: state.account && state.account.privileges && state.account.privileges.isSuperAdmin,
    privilegesIds: state.account && state.account.privileges && state.account.privileges.privileges
});

const mapDispatchToProps = {};

export default injectIntl(withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(AdminDashboard)));